import { useQuery } from "@tanstack/react-query";
import { RightsKeys } from "web_myplann/Api/Rights/RightsKeys";
import { getRightsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useRightsQuery = () => {
	return useQuery({
		queryKey: RightsKeys.all,
		queryFn: processResponse(() => getRightsV2()),
		staleTime: Number.POSITIVE_INFINITY,
	});
};
